<template>
  <v-container fluid>
    <h4 class="mt-4">
      BẢNG HÓA ĐƠN {{ billType.toUpperCase() }}
      <span v-if="tableTitleDate">THÁNG {{ tableTitleDate }}</span>
    </h4>
    <v-data-table :headers="currentTableHeaders" :items="itemsWithTotal" hide-actions class="elevation-1">
      <template slot="items" slot-scope="props">
        <td :class="{ 'text-center text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
          props.item.building }}</td>
        <td :class="{ 'text-center text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
          props.item.customer_code }}</td>
        <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
          props.item.previous_period | formatNumber }}</td>
        <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">{{
          props.item.current_period | formatNumber }}</td>
        <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">
          {{ props.item.consumption | formatNumber }}
        </td>
        <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">
          {{ props.item.unit_price === null ? '' : $options.filters.formatNumber(Math.round(props.item.unit_price)) }}
        </td>
        <td :class="{ 'text-xs-right text-no-wrap': true, 'font-weight-bold': props.item.isTotalRow }">
          {{ props.item.amount_paid | formatCurrency }}
        </td>
      </template>

      <template slot="no-data">
        Không có dữ liệu được trích xuất.
      </template>
    </v-data-table>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="confirmData">Lưu dữ liệu</v-btn>
      <v-btn color="error" @click="rejectData">Dữ liệu sai, thử lại</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
export default {
  name: 'TablePreviewUploadPdfDienNuoc',
  props: {
    extractedData: {
      type: Array,
      default: () => []
    },
    billType: {
      type: String,
      default: 'Nước'
    },
    billDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      waterHeaders: [
        { text: "TÒA NHÀ", align: "center", sortable: false, value: "building" },
        { text: "SDB", align: "center", sortable: false, value: "customer_code" },
        { text: "Số đầu kỳ", align: "right", sortable: false, value: "previous_period" },
        { text: "Số cuối kỳ", align: "right", sortable: false, value: "current_period" },
        { text: "Số tiêu thụ", align: "right", sortable: false, value: "consumption" },
        { text: "Đơn giá nước", align: "right", sortable: false, value: "unit_price" },
        { text: "Số tiền đã nộp", align: "right", sortable: false, value: "amount_paid" },
      ],
      electricityHeaders: [
        { text: "TÒA NHÀ", align: "center", sortable: false, value: "building" },
        { text: "Mã KH", align: "center", sortable: false, value: "customer_code" },
        { text: "Số đầu kỳ", align: "right", sortable: false, value: "previous_period" },
        { text: "Số cuối kỳ", align: "right", sortable: false, value: "current_period" },
        { text: "Số tiêu thụ", align: "right", sortable: false, value: "consumption" },
        { text: "Đơn giá điện", align: "right", sortable: false, value: "unit_price" },
        { text: "Số tiền đã nộp", align: "right", sortable: false, value: "amount_paid" },
      ],
    };
  },
  filters: {
    formatNumber(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return value.toLocaleString('vi-VN');
    },
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      return date.toLocaleDateString('vi-VN');
    },
    formatMonthYear(value) {
      if (!value) return '';
      const date = new Date(value);
      return `${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    },
    formatCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return value.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' }).replace('₫', '');
    }
  },
  computed: {
    currentTableHeaders() {
      if (this.billType === 'Điện') {
        return this.electricityHeaders;
      } else {
        return this.waterHeaders;
      }
    },
    tableTitleDate() {
      if (this.billDate) {
        return this.$options.filters.formatMonthYear(this.billDate);
      }
      return '';
    },
    totalConsumption() {
      return this.extractedData.reduce((sum, item) => sum + (item.consumption || 0), 0);
    },
    totalAmountPaid() {
      return this.extractedData.reduce((sum, item) => sum + (item.amount_paid || 0), 0);
    },
    itemsWithTotal() {
      const items = [...this.extractedData];

      if (!items.length) return [];

      const totalRow = {
        building: 'TỔNG',
        customer_code: null,
        previous_period: null,
        current_period: null,
        consumption: this.totalConsumption,
        unit_price: null,
        amount_paid: this.totalAmountPaid,
        isTotalRow: true
      };

      items.push(totalRow);
      return items;
    }
  },
  methods: {
    confirmData() {
      this.$emit('confirm');
    },
    rejectData() {
      this.$emit('reject');
    }
  }
};
</script>

<style scoped>
.v-data-table th {
  white-space: nowrap;
  font-weight: bold;
}

.fw-bold {
  font-weight: bold;
}

.v-data-table tbody td {
  vertical-align: top;
}

.v-data-table tfoot tr {
  font-weight: bold;
  background-color: #f5f5f5;
}
</style>